import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { take } from 'rxjs/operators';
import { RuleConfig } from '../model/rule-config';
import { TableDTO } from '../model/table-dto';

@Injectable({
  providedIn: 'root'
})
export class RuleConfigService {

  ruleConfigApi: string = environment.api + 'v1/rule_config/';

  constructor(private http: HttpClient) { }

  getOptions(): HttpHeaders {
    const headers = new HttpHeaders()
      .set('content-type', 'application/json')
      .set('Access-Control-Allow-Origin', '*')
      .set('Authorization', `Bearer ${this.getCookie()}`);
    return headers;
  }

  private getCookie(): string {
    const name = 'frontend-app=';
    const ca = document.cookie.split(';');
    // tslint:disable-next-line: prefer-for-of
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length).trim();
      }
    }
    return '';
  }

  async getList(search?: string) {
    const fullUri = search === null ? this.ruleConfigApi + 'list' : this.ruleConfigApi + 'list/' + search;
    return await this.http.get<RuleConfig[]>(fullUri, { headers: this.getOptions() }).toPromise();
  }

  async saveOrUpdate(object: RuleConfig) {
    const fullUri = this.ruleConfigApi + 'newUpdate';
    const json = JSON.stringify(object);
    return await this.http.post<RuleConfig>(fullUri, json, { headers: this.getOptions() }).toPromise();
  }

  async getById(id: number) {
    const fullUri = this.ruleConfigApi + 'getById/' + id;
    return await this.http.get<RuleConfig[]>(fullUri, { headers: this.getOptions() }).toPromise();
  }

  async delete(id: number) {
    const fullUri = this.ruleConfigApi + 'delete/' + id;
    return await this.http.delete<any>(fullUri, { headers: this.getOptions() }).toPromise();
  }

  async makeSync(list: RuleConfig[]) {
    const fullUri = this.ruleConfigApi + 'makeSync';
    const json = JSON.stringify(list);
    return await this.http.post<RuleConfig>(fullUri, json, { headers: this.getOptions() }).toPromise();
  }

  async getTableList() {
    const fullUri = this.ruleConfigApi + 'getTables/';
    return await this.http.get<TableDTO[]>(fullUri, { headers: this.getOptions() }).toPromise();
  }

  async getColumnList(table: string) {
    const fullUri = this.ruleConfigApi + 'getColumns/' + table;
    return await this.http.get<string[]>(fullUri, { headers: this.getOptions() }).toPromise();
  }

}
